<div class="fd-tab-sections FT-performance block-border" id="performance" *ngIf="!isSegregated && !disableTab">
  <div class="block-head" id="top_id">
    <h3>{{ "products.tab-performance" | translate }}
      <!-- <small>{{ "products.performance-cummulative-table-title" | translate }}</small> -->
    </h3>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation" #formatButtons>
        <button data-bs-toggle="tab" data-bs-target="#SIP-tab-pane" role="tab" aria-controls="SIP-tab-pane"
                aria-selected="true" type="button" value="SIP" class="nav-link" (click)="
            isLumpsumActive = false;
            isSIPActive = true;
            onClickOfSIPOrLumpsum($event)" [ngClass]="{ 'active activeFormat' : isSIPActive }">
          {{ "products.performance-cummulative-sip" | translate }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button data-bs-toggle="tab" data-bs-target="#SIP-tab-pane" role="tab" aria-controls="SIP-tab-pane"
                aria-selected="false" type="button" value="Lumpsum" class="nav-link" (click)="
            isSIPActive = false;
            isLumpsumActive = true;
            onClickOfSIPOrLumpsum($event)" [ngClass]="{ 'active activeFormat': isLumpsumActive }">
          {{ "products.performance-cummulative-lumpsum" | translate }}
        </button>
      </li>
    </ul>

  </div>


  <div class="tab-content" id="myTabContent" *ngIf="graphDataLoaded else loaderBlock">
    <div class="tab-pane fade show active" id="SIP-tab-pane" role="tabpanel" aria-labelledby="SIP-tab" tabindex="0"
         *ngIf="performanceData?.inceptionDate">
      <!-- <div class="bg-gradient performance-head">
        <ul class="left-items">
          <li>
            <span class="text-fields">
              {{ "products.performance-cummulative-sip-invested" | translate }}
            </span>
            <div class="bg-white">
              <span>₹</span>
              <div class="form-group d-inline-flex">
                <input type="text" aria-label="amount" class="form-control cust-darkmode" [maxlength]="isSIPActive?7:9"
                       value="10000"
                       [(ngModel)]="performanceModel.investedAmount" (ngModelChange)="onInvestedAmountChange()"/>
              </div>
            </div>
          </li>
          <li class="d-md-inline-block">
            <span *ngIf="isSIPActive; else elseBlock1">{{
                    "products.performance-cummulative-sip-everymonth" | translate
              }}
            </span>
            <ng-template #elseBlock1>
              <span>{{
                      "products.performance-cummulative-lumpsum-invested" | translate
                }}</span>
            </ng-template>
            <div class="date d-inline-block">
              <div class="date-group bg-white d-inline-flex">
                <input aria-label="performancemodel" class="form-control date-field custom-input" type="text"
                       [(ngModel)]="performanceModel.fromDate" readonly="true"/>
                <div>
                  <ft-date-picker [displayDate]="performanceModel.fromDate" [convertToFormat]="'MMM YYYY'"
                                  [sentDateFormat]="'MMM YYYY'" (finalDate)="onFinalDate($event, 'fromDate')"
                                  type="month"
                                  [fundInception]="performanceModel.inceptionDate"
                                  [customLeftPosition]="'calc(0% - 200px)'">
                  </ft-date-picker>
                </div>
              </div>
            </div>
          </li>
          <li class="d-md-inline-block">to
            <div class="date-group bg-white d-inline-flex">
              <input aria-label="performancedate" class="form-control date-field custom-input" type="text"
                     [(ngModel)]="performanceModel.toDate" readonly="true"/>
              <ft-date-picker [displayDate]="performanceModel.formattedToDate" [convertToFormat]="'MMM YYYY'"
                              [sentDateFormat]="'DD-MM-YYYY'" (finalDate)="onFinalDate($event, 'toDate')"
                              [customLeftPosition]="'calc(0% - 200px)'"
                              type="month">
              </ft-date-picker>
            </div>
          </li>

        </ul>
        <ul class="text-center right-items">
          <li><strong>₹ {{
                  performanceModel.sipInvestedAmount | number: "2."
            }}</strong>{{ "products.performance-cummulative-amount-by-you1" | translate }} <br/>
            {{ "products.performance-cummulative-amount-by-you2" | translate }}
          </li>
          <li><strong>₹ {{
                  performanceModel.potentialRtn | number: "2."
            }}</strong>{{ "products.performance-cummulative-potential1" | translate }} <br/>
            {{ "products.performance-cummulative-potential2" | translate }}
          </li>
          <li class="ms-4"><strong>₹ {{
                  performanceModel.maxInvestedAmt | number: "2."
            }}</strong>{{ "products.performance-cummulative-value-of-yours1" | translate }} <br/>
            {{ "products.performance-cummulative-value-of-yours2" | translate }}
          </li>
        </ul>
      </div> -->
      <div class="text-center pb-5 mt-5 field-error" *ngIf="sipLumpError">
        <span> {{ "products.performance-graph-not-available" | translate }}</span>
      </div>
      <span class="field-error" *ngIf="showError">
        {{
              "products.performance-cummulative-min-investment" | translate
        }}
        ₹
        {{
              "products.performance-cummulative-warning-text" | translate
        }}
      </span>
      <!-- <div class="graph-block mb-5" [ngClass]="{ 'd-none': !isChartReady }">
        <div class="performance-graph mb-0 mt-0" #container></div>
        <div class="text-center mt-lg-4 mt-3" style="font-size: 0.75rem;color: #8189A2;">
          <span class="graph-info">{{ "products.performance-graph-info" | translate }}</span>
        </div>
      </div> -->
      <div class="fund-value-table">
        <!-- Perf data loaded successfully -->
        <!-- <div class="mb-3" *ngIf="perfAsOfDate">
          <h6>{{ "products.performance-annualized-table-title" | translate }}
            {{ "products.as-of-capitalize" | translate }} {{ perfAsOfDate }}</h6>
        </div> -->

        <div *ngIf="hasLoaded; else noPerfDataMessage" class="table-responsive mb-5 ">
          <table class="table table-striped mb-2 discrete-performance" *ngIf="!showSipData && showDiscretePerformance">
            <thead id="disc-th">
            <tr>
              <th rowspan="2" class="text-bold" style="vertical-align: bottom;z-index: 1;"> {{
                      "products.performance-annualized-col-header-fund" | translate
                }}
              </th>
              <th colspan="5" class="text-center">
                {{ "products.performance-cummulative-table-cagr" | translate }}
              </th>
              <th colspan="5"
                  class="text-center">{{ "products.performance-cummulative-table-current-val" | translate }}
              </th>
            </tr>
            <tr>
              <th> {{ "products.performance-discrete-row-year-1" | translate }}</th>
              <th> {{ "products.performance-discrete-row-year-2" | translate }}</th>
              <th> {{ "products.performance-discrete-row-year-3" | translate }}</th>
              <th> {{ "products.performance-discrete-row-year-4" | translate }}</th>
              <th> {{ "products.performance-discrete-row-year-5" | translate }}</th>

              <th> {{ "products.performance-discrete-row-year-1" | translate }}</th>
              <th> {{ "products.performance-discrete-row-year-2" | translate }}</th>
              <th> {{ "products.performance-discrete-row-year-3" | translate }}</th>
              <th> {{ "products.performance-discrete-row-year-4" | translate }}</th>
              <th> {{ "products.performance-discrete-row-year-5" | translate }}</th>

            </tr>
            <!-- </tr> -->
            </thead>
            <tbody class="two-side-border disc-tbody">
            <tr>
              <td colspan="12">
                {{ regularPerformanceLabel }}
                {{ "products.as-of-capitalize" | translate }} {{ perfAsOfDate }}
              </td>
            </tr>  
            <tr class="disc-tr-1">
              <td>{{ "products.performance-annualized-col-header-fund" | translate }}</td>
              <td>{{ lumpsumDataDiscrete?.performance?.year1Return }}</td>
              <td>{{ lumpsumDataDiscrete?.performance?.year2Return }}</td>
              <td>{{ lumpsumDataDiscrete?.performance?.year3Return }}</td>
              <td>{{ lumpsumDataDiscrete?.performance?.year4Return }}</td>
              <td>{{ lumpsumDataDiscrete?.performance?.year5Return }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr class="disc-tr-2" *ngFor="let performance of lumpsumDataDiscrete?.bmPerformance">
              <td> {{ performance?.bmName }}</td>
              <td> {{ performance?.year1Return }}</td>
              <td> {{ performance?.year2Return }}</td>
              <td> {{ performance?.year3Return }}</td>
              <td>{{ performance?.year4Return }}</td>
              <td>{{ performance?.year5Return }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td colspan="12">
                {{ "products.performance-direct-plan" | translate }}
                {{ "products.as-of-capitalize" | translate }} {{ perfAsOfDate }}
              </td>
            </tr>
            <tr class="disc-tr-1">
              <td>{{ "products.performance-annualized-col-header-fund" | translate }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year1Return }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year2Return }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year3Return }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year4Return }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year5Return }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr class="disc-tr-2" *ngFor="let performance of lumpsumDataCumulativeDirect?.bmPerformance">
              <td> {{ performance?.bmName }}</td>
              <td> {{ performance?.year1Return }}</td>
              <td> {{ performance?.year2Return }}</td>
              <td> {{ performance?.year3Return }}</td>
              <td>{{ performance?.year4Return }}</td>
              <td>{{ performance?.year5Return }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            </tbody>
          </table>
          <table class="table table-striped" *ngIf="!showSipData">
            <thead *ngIf="lumpsumDataAnnualized?.performance">
            <tr>
              <th rowspan="2" class="text-bold" style="vertical-align: bottom; z-index: 1;"> {{
                      "products.performance-annualized-col-header-fund" | translate
                }}
              </th>
              <th colspan="6" class="text-center">
                {{ "products.performance-cummulative-table-cagr" | translate }}
              </th>
              <th colspan="6"
                  class="text-center">{{ "products.performance-cummulative-table-current-val" | translate }}
              </th>
            </tr>
            <tr>
              <th> {{ "products.performance-annualized-row-year-1" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-3" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-5" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-10" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-15" | translate }}</th>
              <th> {{
                      "products.performance-annualized-row-since-inception" | translate
                }}
              </th>
              <th> {{ "products.performance-annualized-row-year-1" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-3" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-5" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-10" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-15" | translate }}</th>
              <th> {{
                      "products.performance-annualized-row-since-inception" | translate
                }}
              </th>
            </tr>
            <!-- </tr> -->
            </thead>

            <thead *ngIf="lumpsumDataCumulative?.performance">
            <tr>
              <th rowspan="2" class="text-bold" style="vertical-align: bottom;"> {{
                      "products.performance-annualized-col-header-fund" | translate
                }}
              </th>
              <th colspan="6" class="text-center">CAGR</th>
              <th colspan="6" class="text-center">Current Value</th>
            </tr>
            <tr class="cumulative-row-tr">
              <th> {{ "products.performance-annualized-row-year-1" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-3" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-5" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-10" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-15" | translate }}</th>
              <th> {{
                      "products.performance-annualized-row-since-inception" | translate
                }}
                ({{ sinceInceptionReturnDate }})
              </th>
              <th> {{ "products.performance-annualized-row-year-1" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-3" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-5" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-10" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-15" | translate }}</th>
              <th> {{
                      "products.performance-annualized-row-since-inception" | translate
                }}
                ({{ sinceInceptionReturnDate }})
              </th>
            </tr>
            </thead>
            <tbody *ngIf="lumpsumDataAnnualized?.performance"
                   class="{{ lumpsumDataCumulative?.performance ? 'two' : 'three'}}-side-border">
            <tr>
              <td colspan="12">
                {{ regularPerformanceLabel }}
                {{ "products.as-of-capitalize" | translate }} {{ perfAsOfDate }}
              </td>
            </tr>                   
            <tr>
              <td>{{ "products.performance-annualized-col-header-fund" | translate }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year1Return }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year3Return }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year5Return }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year10Return }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year15Return }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.sinceInceptionReturn }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year1CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year3CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year5CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year10CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.year15CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualized?.performance?.sinceInceptionCurrentReturn }}</td>
            </tr>
            <tr *ngFor="let performance of lumpsumDataAnnualized?.bmPerformance">
              <td>{{ performance?.bmName }}</td>
              <td>{{ performance?.year1Return ? performance?.year1Return : '-' }}</td>
              <td>{{ performance?.year3Return ? performance?.year3Return : '-' }}</td>
              <td>{{ performance?.year5Return ? performance?.year5Return : '-' }}</td>
              <td>{{ performance?.year10Return ? performance?.year10Return : '-' }}</td>
              <td>{{ performance?.year15Return ? performance?.year15Return : '-' }}</td>
              <td>{{ performance?.sinceInceptionReturn ? performance?.sinceInceptionReturn : '-' }}</td>
              <td>{{ performance?.year1CurrentReturn ? performance?.year1CurrentReturn : '-' }}</td>
              <td>{{ performance?.year3CurrentReturn ? performance?.year3CurrentReturn : '-' }}</td>
              <td>{{ performance?.year5CurrentReturn ? performance?.year5CurrentReturn : '-' }}</td>
              <td>{{ performance?.year10CurrentReturn ? performance?.year10CurrentReturn : '-' }}</td>
              <td>{{ performance?.year15CurrentReturn ? performance?.year15CurrentReturn : '-' }}</td>
              <td>{{ performance?.sinceInceptionCurrentReturn ? performance?.sinceInceptionCurrentReturn : '-' }}</td>
            </tr>
            <tr>
              <td colspan="12">
                {{ "products.performance-direct-plan" | translate }}
                {{ "products.as-of-capitalize" | translate }} {{ perfAsOfDate }}
              </td>
            </tr>
            <tr>
              <td>{{ "products.performance-annualized-col-header-fund" | translate }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year1Return }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year3Return }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year5Return }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year10Return }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year15Return }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.sinceInceptionReturn }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year1CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year3CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year5CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year10CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.year15CurrentReturn }}</td>
              <td>{{ lumpsumDataAnnualizedDirect?.performance?.sinceInceptionCurrentReturn }}</td>
            </tr>
            <tr *ngFor="let performance of lumpsumDataAnnualizedDirect?.bmPerformance">
              <td>{{ performance?.bmName }}</td>
              <td>{{ performance?.year1Return ? performance?.year1Return : '-' }}</td>
              <td>{{ performance?.year3Return ? performance?.year3Return : '-' }}</td>
              <td>{{ performance?.year5Return ? performance?.year5Return : '-' }}</td>
              <td>{{ performance?.year10Return ? performance?.year10Return : '-' }}</td>
              <td>{{ performance?.year15Return ? performance?.year15Return : '-' }}</td>
              <td>{{ performance?.sinceInceptionReturn ? performance?.sinceInceptionReturn : '-' }}</td>
              <td>{{ performance?.year1CurrentReturn ? performance?.year1CurrentReturn : '-' }}</td>
              <td>{{ performance?.year3CurrentReturn ? performance?.year3CurrentReturn : '-' }}</td>
              <td>{{ performance?.year5CurrentReturn ? performance?.year5CurrentReturn : '-' }}</td>
              <td>{{ performance?.year10CurrentReturn ? performance?.year10CurrentReturn : '-' }}</td>
              <td>{{ performance?.year15CurrentReturn ? performance?.year15CurrentReturn : '-' }}</td>
              <td>{{ performance?.sinceInceptionCurrentReturn ? performance?.sinceInceptionCurrentReturn : '-' }}</td>
            </tr>
            </tbody>

            <!-- 2nd body for cumulative performance details -->
            <tbody *ngIf="lumpsumDataCumulative?.performance" class="three-side-border">
            <tr>
              <td colspan="12">
                {{ regularPerformanceLabel }}
                {{ "products.as-of-capitalize" | translate }} {{ perfAsOfDate }}
              </td>
            </tr>
            <tr>
              <td>{{ "products.performance-annualized-col-header-fund" | translate }}</td>
              <td>{{ lumpsumDataCumulative?.performance?.year1Return }}</td>
              <td>{{ lumpsumDataCumulative?.performance?.year3Return }}</td>
              <td>{{ lumpsumDataCumulative?.performance?.year5Return }}</td>
              <td>{{ lumpsumDataCumulative?.performance?.year10Return }}</td>
              <td>{{ lumpsumDataCumulative?.performance?.year15Return }}</td>
              <td>{{ lumpsumDataCumulative?.performance?.sinceInceptionReturn }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr *ngFor="let performance of lumpsumDataAnnualized?.bmPerformance">
              <td>{{ performance?.bmName }}</td>
              <td>{{ performance?.year1Return }}</td>
              <td>{{ performance?.year3Return }}</td>
              <td>{{ performance?.year5Return }}</td>
              <td>{{ performance?.year10Return }}</td>
              <td>{{ performance?.year15Return }}</td>
              <td>{{ performance?.sinceInceptionReturn }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td colspan="12">
                {{ "products.performance-direct-plan" | translate }}
                {{ "products.as-of-capitalize" | translate }} {{ perfAsOfDate }}
              </td>
            </tr>
            <tr>
              <td>{{ "products.performance-annualized-col-header-fund" | translate }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year1Return }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year3Return }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year5Return }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year10Return }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.year15Return }}</td>
              <td>{{ lumpsumDataCumulativeDirect?.performance?.sinceInceptionReturn }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr *ngFor="let performance of lumpsumDataAnnualizedDirect?.bmPerformance">
              <td>{{ performance?.bmName }}</td>
              <td>{{ performance?.year1Return }}</td>
              <td>{{ performance?.year3Return }}</td>
              <td>{{ performance?.year5Return }}</td>
              <td>{{ performance?.year10Return }}</td>
              <td>{{ performance?.year15Return }}</td>
              <td>{{ performance?.sinceInceptionReturn }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            </tbody>
          </table>

          <table class="table table-striped" *ngIf="showSipData && sipData?.length">
            <thead>
            <tr>
              <th rowspan="2" class="text-bold" style="vertical-align: bottom;"> {{
                      "products.performance-annualized-col-header-fund" | translate
                }}
              </th>
              <th colspan="6" class="text-center">CAGR</th>
              <th colspan="6" class="text-center">Current Value</th>
            </tr>
            <tr class="cumulative-row-tr">
              <th> {{ "products.performance-annualized-row-year-1" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-3" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-5" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-10" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-15" | translate }}</th>
              <th> {{
                      "products.performance-annualized-row-since-inception" | translate
                }}
                ({{ sinceInceptionReturnDate }})
              </th>
              <th> {{ "products.performance-annualized-row-year-1" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-3" | translate }}</th>
              <th>{{ "products.performance-annualized-row-year-5" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-10" | translate }}</th>
              <th> {{ "products.performance-annualized-row-year-15" | translate }}</th>
              <th> {{
                      "products.performance-annualized-row-since-inception" | translate
                }}
                ({{ sinceInceptionReturnDate }})
              </th>
            </tr>
            </thead>

            <tbody class="three-side-border">
            <tr>
              <td colspan="12">
                {{ regularPerformanceLabel }}
                {{ "products.as-of-capitalize" | translate }} {{ perfAsOfDate }}
              </td>
            </tr>
            <tr *ngFor="let sipRecord of sipData">
              <td>{{ sipRecord.bmName }}</td>
              <td>{{ sipRecord.year1Return ? sipRecord.year1Return : '-' }}</td>
              <td>{{ sipRecord.year3Return ? sipRecord.year3Return : '-' }}</td>
              <td>{{ sipRecord.year5Return ? sipRecord.year5Return : '-' }}</td>
              <td>{{ sipRecord.year10Return ? sipRecord.year10Return : '-' }}</td>
              <td>{{ sipRecord.year15Return ? sipRecord.year15Return : '-' }}</td>
              <td>{{ sipRecord.sinceInceptionReturn ? sipRecord.sinceInceptionReturn : '-' }}</td>
              <td>{{ sipRecord.year1CurrentReturn ? sipRecord.year1CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.year3CurrentReturn ? sipRecord.year3CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.year5CurrentReturn ? sipRecord.year5CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.year10CurrentReturn ? sipRecord.year10CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.year15CurrentReturn ? sipRecord.year15CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.sinceInceptionCurrentReturn ? sipRecord.sinceInceptionCurrentReturn : '-' }}</td>
            </tr>
            <tr>
              <td colspan="12">
                {{ "products.performance-direct-plan" | translate }}
                {{ "products.as-of-capitalize" | translate }} {{ perfAsOfDate }}
              </td>
            </tr>
            <tr *ngFor="let sipRecord of sipDataDirect">
              <td>{{ sipRecord.bmName }}</td>
              <td>{{ sipRecord.year1Return ? sipRecord.year1Return : '-' }}</td>
              <td>{{ sipRecord.year3Return ? sipRecord.year3Return : '-' }}</td>
              <td>{{ sipRecord.year5Return ? sipRecord.year5Return : '-' }}</td>
              <td>{{ sipRecord.year10Return ? sipRecord.year10Return : '-' }}</td>
              <td>{{ sipRecord.year15Return ? sipRecord.year15Return : '-' }}</td>
              <td>{{ sipRecord.sinceInceptionReturn ? sipRecord.sinceInceptionReturn : '-' }}</td>
              <td>{{ sipRecord.year1CurrentReturn ? sipRecord.year1CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.year3CurrentReturn ? sipRecord.year3CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.year5CurrentReturn ? sipRecord.year5CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.year10CurrentReturn ? sipRecord.year10CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.year15CurrentReturn ? sipRecord.year15CurrentReturn : '-' }}</td>
              <td>{{ sipRecord.sinceInceptionCurrentReturn ? sipRecord.sinceInceptionCurrentReturn : '-' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="block-footer">
        <span [innerHtml]="annualizedCaveats"></span>
        <!-- <div class="download-plan">
          <a *ngIf="linkFromLiteratureService.textLink" target="_blank" [href]="linkFromLiteratureService.textLink">
            <img alt="Open PDF" src="assets/images/home/pdf.svg">{{ "products.fundManagerLinkText" | translate }}</a>
        </div> -->
      </div>
      <!-- No perf data message -->
      <ng-template #noPerfDataMessage>
        <span *ngIf="hasLoaded !== undefined; else perfDataLoading">
          {{ "products.performance-annualized-no-perf-data" | translate }}
        </span>
      </ng-template>

      <!-- Perf data loading message -->
      <ng-template #perfDataLoading>
        <span>
          {{ "products.performance-annualized-perf-data-loading" | translate }}
        </span>
      </ng-template>

    </div>
  </div>

  <ng-template #loaderBlock>
    <div class="text-center pb-5 mt-5">
      <div id="loader">
        <img src="assets/images/home/loader.gif" alt="Loading...">
      </div>
    </div>
  </ng-template>
</div>
